import React from "react";
import { useField } from "formik";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import FormInputShell, { InputShell } from "./FormInputShell";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  typography: {
    fontSize: 14,
    padding: 8,
    border: "1px solid grey",
    borderRadius: 5,
    color: theme.palette.common.grey,
    minHeight: 100,
    display: "flex",
    alignItems: "center",
  },
}));

const SimpleTextareaInput = ({ label, readOnly, customStyle, buttons, ...props }: any) => {
  const classes = useStyles();

  return (
    <InputShell label={label} name={props.name} button={buttons}>
      {readOnly ? (
        <Typography className={classes.typography} variant="body1" gutterBottom>
          {props?.readonlyvalue || ""}
        </Typography>
      ) : (
        <TextField
          multiline
          variant="outlined"
          fullWidth
          {...props}
          InputProps={{
            style: {
              padding: 8,
              ...customStyle,
            },
          }}
        />
      )}
    </InputShell>
  );
};

const TextareaInput = ({ readOnly, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <>
      {readOnly ? (
        <Typography variant="body1" gutterBottom>
          {props.readonlyvalue}
        </Typography>
      ) : (
        <TextField
          multiline
          rows={1}
          minRows={1}
          maxRows={10}
          variant="outlined"
          fullWidth
          error={meta.touched && !!meta.error}
          {...field}
          {...props}
          sx={{
            "& .MuiInputBase-root": {
              display: "flex",
              alignItems: "center",
              padding: "0px !important",
            },
            "& .MuiOutlinedInput-input": {
              padding: "0px !important",
            },
          }}
        />
      )}
      <FormHelperText error={meta.touched && !!meta.error}>
        {meta.touched && meta.error}
      </FormHelperText>
    </>
  );
};

const FormTextareaInput = ({ label, ...props }: any) => (
  <FormInputShell label={label} name={props.name}>
    <TextareaInput {...props} />
  </FormInputShell>
);

// @ts-ignore - MUI TextField component doesn't expose propTypes in TypeScript
FormTextareaInput.propTypes = TextField.propTypes;

export default FormTextareaInput;
export { TextareaInput, SimpleTextareaInput };
